import { colours } from "./colours";
import { Line } from "react-chartjs-2";
import { Placeholder } from "react-bootstrap";
import { useMemo, memo } from "react";

const getRenderOrder = (key) => {
  if (key === 'Interruptions') return 1;
  else if (key === 'Positive') return 2;
  else if (key === 'Negative') return 1;
  else if (key === 'Neutral') return 3;
  else if (key.indexOf('Customer') >= 0) return 5;
  else return 10;
}

const ComprehendSentimentChartComponent = ({ comprehendSentimentData, speakerLabels }) => {
  const datasets = useMemo(() => {
    if (!comprehendSentimentData || !speakerLabels) {
      return [];
    }

    const result = [];
    Object.keys(speakerLabels).forEach((key) => {
      if (key in comprehendSentimentData && comprehendSentimentData[key]) {
        result.push({
          label: speakerLabels[key],
          data: comprehendSentimentData[key],
          backgroundColor: colours[key] || '#6B7280',
          borderColor: colours[key] || '#6B7280',
          order: getRenderOrder(speakerLabels[key]),
          type: "line",
          tension: 0.1,
          pointRadius: 0,
        });
      }
    });
    return result;
  }, [comprehendSentimentData, speakerLabels]);

  // If no data available, show placeholder
  if (!comprehendSentimentData || !speakerLabels) {
    return <Placeholder />
  }

  // If no valid datasets, show placeholder
  if (datasets.length === 0) {
    return <Placeholder />
  }

  const chartKey = `sentiment-chart-${datasets.length}`;

  return (
    <Line
      key={chartKey}
      redraw={true}
      aria-label="This is a chart showing speaker and caller sentiment per second."
      height={70}
      data={{
        type: 'line',
        /*labels: Object.keys(speakerLabels),*/
        datasets: datasets,
        /*datasets: [
          {
            label: "Loudness",
            data: data,
            backgroundColor: colours[caller],
            borderColor: colours[caller],
            barThickness: 20,
            order: 1,
          },
          {
            data: interruptions,
            label: "Interruption",
            backgroundColor: "rgba(252,232,83,0.6)",
            skipNull: true,
            type: "bar",
            barThickness: 30,
            order: 1,
          },
        ],*/
      }}
      options={{
        scales: {
          x: {
            type: "linear",
            stacked: true,
            offset: false,
            display: true,
            position: "left",
            title: { text: "Seconds", display: true },
          },
          y: {
            display: true,
            stacked: false,
            offset: false,
            position: "left",
            title: { text: "Sentiment (-5 to 5)", display: true },
            suggestedMin: -5,
            suggestedMax: 5
          },
        },
        plugins: {
          legend: {
            display: true,
            labels: {
              filter: function (item, chart) {
                if (item.text.includes('Positive') ||
                  item.text.includes('Negative') ||
                  item.text.includes('Neutral')
                ) return false;
                return true;
              }
            }
          },
        },
      }}
    />
  );
};

export const ComprehendSentimentChart = memo(ComprehendSentimentChartComponent);
